import React, { useEffect } from 'react'
import '../hometabs/HomeTabs.css'
import useApi from '../../customHook/useApi';
import { useSelector } from 'react-redux';

const FollowingTabs = () => {
    const { userId } = useSelector((state) => state.user);
    const { data: followingData, get: getFollowing } = useApi('https://codezens.com/luststory/index.php/api');
    const { data: postsData, get: getPosts } = useApi('https://codezens.com/luststory/index.php/api/');

    useEffect(() => {
        // Fetch the following users
        getFollowing(`/get_following?auth_id=${userId}`);
        // Fetch the posts
        getPosts(`/get_posts?auth_id=${userId}&status=Following`);
    }, [getFollowing, getPosts, userId]);

    return (
        <div className='tabs-homepage'>
            <div className='tabs-head'>
                <ul className='d-flex flex-wrap justify-content-center'>
                    {followingData?.result?.map((user) => (
                        <li key={user.user_id}>
                            <span className="tabs-img"><img src={user.user_image} alt='user-img' /></span>
                            <span className="tabs-text">{user.name}</span>
                        </li>
                    ))}

                </ul>
            </div>
            <div className='tabs-bottom-box'>

                {postsData?.result?.map((post) => (
                    <div className="tabs-box" key={post.post_id}>
                        <div className="tabs-content d-flex flex-wrap align-items-center">
                            <div className="left-img"><img src={post.user_image} alt='following-img' /></div>
                            <div className="right-box">
                                <h5>
                                    {post.username} <span>{post.created_at}</span>
                                </h5>
                                <p>{post.description}</p>
                            </div>
                        </div>
                        {post.image?.length > 0 && (
                            <div className="two-img-box">
                                <ul className="d-flex flex-wrap">
                                    {post.image.map((image, index) => (
                                        <li key={index} className="img-box">
                                            <img src={image} alt="post-img" />
                                        </li>
                                    ))}
                                    {post.video?.map((video, index) => (
                                        <li key={index} className="video-box">
                                            <video width="100%" controls>
                                                <source src={video} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default FollowingTabs
